/**
 * Step 5 — Contextual platform rules: pricing and contact/URL/redirect.
 * Pricing allowed only in quote context; contact/URL blocked in free text everywhere.
 */

import { normalizeForValidation } from './normalizeText.js';

/**
 * @param {string} text
 * @param {string} context - e.g. 'message' | 'review' | 'quote' | 'support' | 'post' | 'description'
 * @param {import('./contentSafetyConfig.js').defaultContentSafetyConfig} config
 * @returns {{ valid: boolean, errorCode?: string, message?: string }}
 */
export function checkPolicyRules(text, context, config) {
  const normalized = normalizeForValidation(text || '', { lowercase: true });
  if (!normalized.length) return { valid: true };

  const pricingAllowed = (config.pricingAllowedContexts || []).includes(context);
  const contactPatterns = config.contactPatterns || {};
  const redirectPhrases = config.redirectPhrases || [];
  const pricingPatterns = config.pricingPatterns || {};
  const messages = config.messages || {};

  // Contact / URL / email — always block in free text
  if (contactPatterns.phone && contactPatterns.phone.test(normalized)) {
    return { valid: false, errorCode: 'CONTACT_NOT_ALLOWED', message: messages.contactNotAllowed };
  }
  if (contactPatterns.email && contactPatterns.email.test(normalized)) {
    return { valid: false, errorCode: 'CONTACT_NOT_ALLOWED', message: messages.contactNotAllowed };
  }
  if (contactPatterns.url && contactPatterns.url.test(normalized)) {
    return { valid: false, errorCode: 'CONTACT_NOT_ALLOWED', message: messages.contactNotAllowed };
  }

  // Redirect phrases
  for (const phrase of redirectPhrases) {
    if (normalized.includes(phrase)) {
      return { valid: false, errorCode: 'REDIRECT_PHRASE', message: messages.redirectPhrase };
    }
  }

  // Pricing — block if not in allowed context
  if (!pricingAllowed) {
    if (pricingPatterns.currencySymbols && pricingPatterns.currencySymbols.test(normalized)) {
      return { valid: false, errorCode: 'PRICING_NOT_ALLOWED', message: messages.pricingNotAllowed };
    }
    if (pricingPatterns.priceLike && pricingPatterns.priceLike.test(normalized)) {
      return { valid: false, errorCode: 'PRICING_NOT_ALLOWED', message: messages.pricingNotAllowed };
    }
  }

  return { valid: true };
}
